import React from 'react';

export const PtsdAssaultAuthoritiesDescription = (
  <div>
    <h3 className="vads-u-font-size--h5">Reports from authorities</h3>
    <p>
      If you’d like us to get reports from military or civilian authorities,
      please provide a name and a mailing address for each person we should
      contact. If you already have copies of their statements, you’ll be able to
      upload those on the next screen.
    </p>
  </div>
);
